// extracted by mini-css-extract-plugin
module.exports = {"CountryFlag":"CountryFlag_CountryFlag__NW5U6"};